










































import { Component, Vue, Prop } from "vue-property-decorator";
import { getClientInfo } from "@/data/repository/ClientRepository";
import ViewAsChipComponent from "@/components/common/ViewAsChip.vue";
import { getViewAsUser } from "@/utils/ViewAs";

import { getBranchName } from "@/data/models/Branch";
import { BranchFilter } from "@/data/models/BranchFilter";
import User from "@/data/models/User";
import {
  getToolbarContextClientName,
  getToolbarContextUserText,
} from "@/utils/ToolbarContext";

@Component({
  components: { "view-as-chip": ViewAsChipComponent },
})
export default class CompanyHeaderComponent extends Vue {
  clientInfo = getClientInfo();

  @Prop({ default: null })
  activeUser!: User | null;

  @Prop({ default: null })
  selectedBranchFilter!: BranchFilter | null;

  @Prop({ default: true })
  showBranch!: boolean;

  @Prop({ default: false })
  disableAutoHide!: boolean;

  /** Shows the "Sicht auf" chip after the context: for a header placed in the bar's centre. */
  @Prop({ default: false })
  showViewAs!: boolean;

  hasMultipleBranches = this.clientBranches;
  shouldHideLeftHeader = false;

  get hasViewAsChip() {
    return this.showViewAs && getViewAsUser() !== null;
  }

  get clientBranches() {
    return this.clientInfo?.branches.length ? this.clientInfo?.branches.length > 1 : false;
  }

  get clientName() {
    return getToolbarContextClientName(this.clientInfo);
  }

  get signedInAsText() {
    return getToolbarContextUserText(
      this.activeUser,
      (key: string, params: string[]) => this.$t(key, params).toString(),
    );
  }

  get branchText() {
    if (!this.showBranch || !this.selectedBranchFilter) {
      return null;
    }

    const branchFilter = this.selectedBranchFilter;

    const branchName = branchFilter.branch
      ? getBranchName(branchFilter.branch)
      : this.$t("common.all");

    return this.$t("clientData.formatBranch", [branchName]).toString();
  }

  get combinedTextLength() {
    const clientName = this.$refs.clientName as HTMLElement;
    const signedInAs = this.$refs.signedInAs as HTMLElement;
    const branch = this.$refs.branch as HTMLElement;
    const viewAs = this.$refs.viewAs as HTMLElement;

    return (
      (clientName?.offsetWidth || 0) +
      (signedInAs?.offsetWidth || 0) +
      (branch?.offsetWidth || 0) +
      (viewAs?.offsetWidth || 0)
    );
  }

  calculateVisibility() {
    if (this.disableAutoHide) {
      this.shouldHideLeftHeader = false;
      return;
    }

    this.$nextTick(() => {
      const toolbarWidth = Number(localStorage.getItem("toolbarWidth")) - 120;
      const companyHeaderWidth = this.combinedTextLength;
      const toolbarMenuWidth_ = Number(localStorage.getItem("toolbarMenuWidth"));
      const toolbarMenuWidth = !toolbarMenuWidth_ || toolbarMenuWidth_ === 0 ? 380 : toolbarMenuWidth_;

      this.shouldHideLeftHeader = companyHeaderWidth + toolbarMenuWidth > toolbarWidth;
    });
  }

  mounted() {
    this.calculateVisibility();
    window.addEventListener("resize", this.calculateVisibility);
  }

  beforeDestroy() {
    window.removeEventListener("resize", this.calculateVisibility);
  }
}
